import cashBookInstance from '../../cashBook/instance'

export const getCashBookRecordsFormatDateV = (dateFrom, dateTo) => {
	return cashBookInstance.get('/cash-book/records/datev/zip?'
		+ (dateFrom ? 'dateFrom=' + dateFrom : '')
		+ (dateTo ? '&dateTo=' + dateTo : ''), { responseType: 'arraybuffer' })
}
